<template>
  <Tooltip v-bind="$attrs" :content="content" placement="top" :transfer="true">
    <div class="twoLinesWrap">{{ text }}</div>
  </Tooltip>
</template>
<script>
  export default {
    name: 'EllipsisTooltip',
    props: {
      content: {
        type: String,
        default: '',
      },
    },
    computed: {
      text() {
        return this.content;
      },
    },
  };
</script>
<style scoped>
.twoLinesWrap{
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
